var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test_mains"},[_vm._m(0),_c('div',{staticClass:"question_box"},[_c('div',{staticClass:"content"},[_c('h6',[_vm._v("请完成以下关于您的必选测试题目")]),_c('Question')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('h5',[_vm._v("升学途径分析"),_c('span')]),_c('p',{staticClass:"remind"},[_c('span',[_vm._v("*")]),_vm._v("为了给您出具合理的升学建议，请您根据您的实际情况认真作答！")])])
}]

export { render, staticRenderFns }